module.exports = __webpack_public_path__ + "img/20200614_111315.c8fa9e10.jpg";